import React from 'react';
import axios from 'axios';
import {WithContext as ReactTags} from "react-tag-input";
import './style.css';

export default class TagInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tags: this.props.tags,
            suggestions: []
        };
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
    }

    componentDidMount() {
        this.getSuggestions();
    }

    getSuggestions() {
        axios.get(this.props.api.tags)
        .then((response) => {
            let suggestions = response.data.map((tag) => tag.name);
            this.setState({
                suggestions
            })
        })
        .catch((error) => {
            console.log("Axios error: ", error);
        })
    }

    handleDelete(i) {
      const { tags } = this.state;
      const newTags = tags.filter((tag, index) => index !== i);
      this.setState({
        tags: newTags
      });
      this.props.handleChangeQuestionTags(newTags);
    }

    handleAddition(tag) {
        let tags = this.state.tags;
        const newTag = {
            name: tag,
        };
        if (tags.find(t => t.name === tag) === undefined) {
            tags.push(newTag);
        }
        this.setState({
            tags
        });
        this.props.handleChangeQuestionTags(tags);
    }

    handleDrag(tag, currPos, newPos) {
      const tags = [...this.state.tags];
      const newTags = tags.slice();

      newTags.splice(currPos, 1);
      newTags.splice(newPos, 0, tag);

      // re-render
      this.setState({ tags: newTags });

      this.props.handleChangeQuestionTags(newTags);
    }

    render() {
        const { tags, suggestions } = this.state;
        return (
            <div>
                <ReactTags
                  tags={tags}
                  suggestions={suggestions}
                  placeholder="Přidat nový tag"
                  labelField={'name'}
                  handleDelete={this.handleDelete}
                  handleAddition={this.handleAddition}
                  handleDrag={this.handleDrag}
                />
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/TagInput/index.js
 **/